import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationtaxiserviceinthane() {



const cardData = {
  keyword: "Outstation Taxi Service in Thane",
  heading: "Lotus Cab: Outstation Taxi Service in Thane",

  headingDescription:
    "Lotus Cab provides reliable and affordable Outstation Taxi Service in Thane for comfortable long-distance travel across Maharashtra and other states. Whether you are planning a family vacation, corporate trip, pilgrimage tour, weekend getaway, or same-day return journey, we offer AC sedans, SUVs, luxury cars, and mini buses with professional chauffeurs. Our one-way and round-trip packages come with transparent per-kilometer pricing and flexible travel schedules. All vehicles are well-maintained, sanitized, and GPS-enabled for safe highway travel. With 24/7 customer support and instant online booking options, Lotus Cab ensures a smooth, punctual, and stress-free outstation cab experience from Thane.",

  top: "Top Places to Visit in Thane with Lotus Cab",

  topPlaces: [
    {
      title: "Upvan Lake",
      description:
        "Upvan Lake is one of Thane’s most peaceful and scenic destinations, ideal for family outings and evening relaxation. The lake is surrounded by lush greenery and walking paths, making it perfect for a calm getaway before heading on an outstation journey. Booking an outstation cab from Thane ensures convenient pickup from nearby residential areas. Our AC vehicles provide comfortable travel during all seasons. Ideal starting point for weekend road trips. Lotus Cab ensures punctual pickup and smooth travel planning."
    },
    {
      title: "Yeoor Hills",
      description:
        "Yeoor Hills is a popular nature retreat in Thane offering fresh air and scenic views. Many travelers begin their long-distance trips from this region due to its connectivity. Outstation taxi service from Thane provides convenient pickup from hill areas. SUV options are ideal for slightly elevated roads. Comfortable seating ensures relaxed travel. Perfect for weekend trip departures."
    },
    {
      title: "Masunda Lake",
      description:
        "Masunda Lake, also known as Talao Pali, is centrally located and easily accessible. Many families book outstation cabs from this busy hub. AC sedan and SUV options ensure comfortable travel even in peak traffic hours."
    },
    {
      title: "Suraj Water Park",
      description:
        "A popular family attraction where travelers often plan weekend trips afterward. Our outstation cabs provide easy pickup and drop from nearby locations. Spacious vehicles are suitable for family groups."
    },
    {
      title: "Korum Mall",
      description:
        "Major commercial hub where corporate clients often schedule outstation trips. Professional chauffeurs ensure punctual corporate travel."
    },
    {
      title: "Ghodbunder Road",
      description:
        "Well-connected highway stretch ideal for starting long-distance journeys. Our outstation taxi service ensures smooth highway entry and efficient route planning."
    }
  ],

  services: [
    {
      name: "Thane Outstation Cab",
      description:
        "Reliable Thane outstation cab service for long-distance travel across Maharashtra and neighboring states. We provide AC sedans, SUVs, and luxury vehicles suitable for family and corporate trips. Our professional chauffeurs are experienced in highway driving and ensure safe, smooth travel. Transparent per-km pricing helps customers plan budgets easily. Flexible one-way and round-trip packages are available. Ideal for business travel, pilgrimages, and weekend getaways."
    },
    {
      name: "One Way Taxi Thane to Nearby Cities",
      description:
        "Affordable one-way taxi from Thane to Mumbai, Pune, Nashik, and other cities. Pay only for one-side distance without return charges. AC vehicles provide comfortable long-distance travel. Professional drivers ensure timely arrival. Ideal for airport drops and corporate travel."
    },
    {
      name: "Round Trip Cab Thane",
      description:
        "Flexible round-trip taxi service from Thane with return scheduling convenience. Suitable for family trips, corporate meetings, and pilgrimage tours. Transparent billing structure provided before departure."
    },
    {
      name: "SUV Cab Outstation Thane",
      description:
        "Spacious SUV taxis for group travel and extra luggage requirements. Powerful highway performance ensures stable and safe travel. Comfortable seating for long journeys."
    },
    {
      name: "Luxury Cab Thane Outstation",
      description:
        "Premium luxury vehicles available for executive and VIP travel needs. Elegant interiors and professional chauffeurs included."
    },
    {
      name: "Mini Bus Thane Outstation",
      description:
        "Mini bus options available for large family trips, corporate events, and group tours. Comfortable seating and long-distance travel support."
    },
    {
      name: "Chauffeur Driven Cab Thane",
      description:
        "Experienced, background-verified drivers ensure safety and punctuality. Professional service with customer-friendly attitude."
    },
    {
      name: "Online Booking Cab Thane",
      description:
        "Instant online booking with transparent fare details and 24/7 support. Quick confirmation and hassle-free reservation process."
    }
  ],

  tableData: [
    ["Thane Outstation Cab", "One Way Taxi Thane to Nearby Cities"],
    ["Round Trip Cab Thane", "AC Cab Outstation Thane"],
    ["Sedan Cab Outstation Thane", "SUV Cab Outstation Thane"],
    ["Luxury Cab Thane Outstation", "Family Trip Cab Thane"],
    ["Corporate Cab Thane Outstation", "Weekend Trip Cab Thane"],
    ["Mini Bus Thane Outstation", "Online Booking Cab Thane"],
    ["Chauffeur Driven Cab Thane", "Picnic Trip Cab Thane"],
    ["Budget Cab Thane", "Same Day Return Cab Thane"],
    ["Per Km Rate Cab Thane", "Best Cab Service Thane"],
    ["Group Travel Cab Thane", "Long Distance Taxi Thane"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Reliable Highway Travel",
      WhyChoosedescription:
        "Our outstation taxi service ensures safe and smooth long-distance travel with experienced drivers familiar with major highways."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Clear fare breakdown provided before booking with no hidden charges."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options",
      WhyChoosedescription:
        "Choose from sedans, SUVs, luxury cars, and mini buses based on your travel needs."
    },
    {
      WhyChooseheading: "24/7 Customer Support",
      WhyChoosedescription:
        "Round-the-clock assistance for booking, route planning, and emergency support."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription:
        "Background-verified drivers trained for long-distance and interstate travel."
    },
    {
      WhyChooseheading: "Clean & Sanitized Fleet",
      WhyChoosedescription:
        "Regularly serviced vehicles maintained for comfort and hygiene."
    },
    {
      WhyChooseheading: "Flexible Booking Options",
      WhyChoosedescription:
        "One-way, round-trip, and same-day return packages available."
    },
    {
      WhyChooseheading: "Corporate & Group Travel Support",
      WhyChoosedescription:
        "Dedicated solutions for corporate clients, family groups, and event transportation."
    }
  ]
};

const faqData = [
  {
    question: "Do you provide one-way outstation taxi from Thane?",
    answer:
      "Yes, we offer one-way taxi service from Thane to nearby cities and long-distance destinations. Customers only pay for one-side distance. Transparent pricing is shared before confirmation. Ideal for airport drops and corporate travel."
  },
  {
    question: "Are SUVs available for outstation travel?",
    answer:
      "Yes, spacious SUVs are available for group and family travel. They provide comfortable seating and luggage space for long journeys."
  },
  {
    question: "Is round-trip booking available?",
    answer:
      "Yes, flexible round-trip packages are available with return scheduling options."
  },
  {
    question: "Are luxury vehicles available?",
    answer:
      "Yes, we provide premium luxury cabs for executive travel and special occasions."
  },
  {
    question: "Is online booking available?",
    answer:
      "Yes, customers can book instantly online with transparent pricing and confirmation."
  },
  {
    question: "Are drivers professional?",
    answer:
      "All chauffeurs are experienced, background-verified, and trained for highway travel."
  },
  {
    question: "Do you provide mini bus for group travel?",
    answer:
      "Yes, mini bus options are available for corporate events and large family trips."
  },
  {
    question: "Is same-day return possible?",
    answer:
      "Yes, same-day return packages are available depending on destination."
  },
  {
    question: "Are fares calculated per km?",
    answer:
      "Yes, transparent per-kilometer pricing is provided before booking confirmation."
  },
  {
    question: "Is customer support available 24/7?",
    answer:
      "Yes, our support team is available round-the-clock for assistance."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshpande",
    feedback:
      "Booked outstation cab from Thane for family trip. The SUV was spacious and comfortable. Driver was professional and punctual. Pricing was transparent and reasonable.",
    rating: 5
  },
  {
    id: 2,
    name: "Corporate Client",
    feedback:
      "Reliable corporate outstation taxi service from Thane. Proper billing support and timely arrival. Highly professional drivers.",
    rating: 5
  },
  {
    id: 3,
    name: "Mrs. Ritu Shah",
    feedback:
      "Used round-trip cab from Thane. Smooth travel experience with clean vehicle and safe driving.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Sagar Patil",
    feedback:
      "Affordable pricing and quick online booking. Great experience for weekend trip.",
    rating: 5
  }
];


































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Taxi Service in Thane",
  "image": "https://lotuscab.com/assets/images/outstation-taxi-thane.jpg",
  "description": "Book outstation taxis from Thane with Lotus Cab. Choose from AC, sedan, SUV, luxury cabs, Mini Bus, or chauffeur-driven rides for one-way or round trips, family trips, corporate travel, weekend trips, and long-distance journeys. Affordable per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "850"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "399",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/outstation-taxi-thane"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Outstation Taxi Service in Thane | Lotus Cab | Call +91 8767592195</title>
  <meta 
    name="description" 
    content="Book reliable outstation taxis from Thane with Lotus Cab. AC, sedan, SUV, luxury cabs, Mini Bus & chauffeur-driven rides for one-way, round trips, family trips, corporate travel, weekend & long-distance trips. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Thane Outstation Cab, One Way Taxi Thane to Nearby Cities, Round Trip Cab Thane, AC Cab Outstation Thane, Sedan Cab Outstation Thane, SUV Cab Outstation Thane, Luxury Cab Thane Outstation, Family Trip Cab Thane, Corporate Cab Thane Outstation, Weekend Trip Cab Thane, Mini Bus Thane Outstation, Online Booking Cab Thane, Chauffeur Driven Cab Thane, Picnic Trip Cab Thane, Budget Cab Thane, Same Day Return Cab Thane, Per Km Rate Cab Thane, Best Cab Service Thane, Group Travel Cab Thane, Long Distance Taxi Thane" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationtaxiserviceinthane;